// extracted by mini-css-extract-plugin
module.exports = {"root":"eFAx5DJU"};